import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Steps from "./partials/Steps";
import { SET_CURRENT_LANGUAGE, TOGGLE_CART } from "../../constants/ActionTypes";
import { LANGUAGE_FR_CODE } from "../../constants/AppConstants";
import i18next from "i18next";
import { getUserInformation } from "../../store/actions";
import i18n from "../../../../i18n/i18n";
import { I18nextProvider } from "react-i18next";

/**
 * Main sidebar
 *
 * @returns
 */
const SideBar = () => {
  const dispatch = useDispatch();
  const checkout = useSelector(state => state.checkout.checkout);
  const isCartOpen = useSelector(state => state.common.isCartOpen);
  const langCode = document.getElementById("language-code")?.value || LANGUAGE_FR_CODE;

  useEffect(() => {
    dispatch({
      type: SET_CURRENT_LANGUAGE,
      payload: langCode,
    });
    if (langCode?.length === 5) {
      i18next.changeLanguage(langCode);
    }
    dispatch(getUserInformation());
  }, []);

  const handleOutsideClick = () => {
    dispatch({
      type: TOGGLE_CART,
      payload: false,
    });
  };

  useEffect(() => {
    /**
     * we need this to close cart when user click in any place in the current DOM
     * @param event
     */
    const handleClickOutside = event => {
      const reactAppContainer = document.getElementById("cart-menu");
      if (reactAppContainer && !reactAppContainer.contains(event.target)) {
        handleOutsideClick();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Suspense fallback={<div className="loader"></div>} className="main-container">
      <I18nextProvider i18n={i18n}>
        <div className={`cart-sidebar  ${isCartOpen && "open"}`}>
          <div>
            <Header />
            <Steps />
            {checkout?.lines?.edges?.length > 0 && <Footer checkout={checkout} />}
          </div>
        </div>
      </I18nextProvider>
    </Suspense>
  );
};
export default SideBar;
